import dispatcher from '../dispatcher';
import scrollStore from '../scroll/scroll.store';
import cursorStore from '../cursor/cursor.store';

var elementProto = Object.create(HTMLElement.prototype);

var _handleStore = function() {
	var moveEvent;
	var smoothPosition = cursorStore.getData().smoothPosition;
	var self = this;

	if (this._active) {
		this.style.transform = 'translateX(' + smoothPosition.x + 'px)'
			+ 'translateY(' + smoothPosition.y + 'px) translateZ(0px)';
	}
}

var _handleDispatcher = function(e) {
	var self = this;
	var cursorStoreData = cursorStore.getData();

	if (e.type === 'cursor:show') {
		clearTimeout(this._to);
		if (!this._active) {
			dispatcher.dispatch({
				type: 'cursor:set-smooth-position',
				position: cursorStoreData.cursorPosition
			});
		}
		this.classList.add('active');
		this._active = true;
		this._area = e.area || null;
	}
	if (e.type === 'cursor:hide'
		|| e.type === 'content:replaced') {
		clearTimeout(this._to);
		this.classList.remove('active');
		this._to = setTimeout(function() {
			self._area = null;
			self._active = false;
		}, 400);
	}
	if (e.type === 'cursor:force-position') {
		clearTimeout(this._to);
		this.classList.add('active');
		this._area = e.area || null;

		if (!this._active) {
			dispatcher.dispatch({
				type: 'cursor:set-smooth-position',
				position: e.position
			});
			this._active = true;
			this.classList.add('active');
		}
	}
	if (e.type === 'cursor:splash') {
		this.classList.add('splash');
		setTimeout(function() {
			self.classList.remove('splash');
		}, 450);
	}
}

elementProto.createdCallback = function() {
	this._active = false;

	this.handleStore = _handleStore.bind(this);
	this.handleDispatcher =  _handleDispatcher.bind(this);
}
elementProto.attachedCallback = function() {
	if (Modernizr.touchevents) return;
	dispatcher.subscribe(this.handleDispatcher);
	cursorStore.subscribe(this.handleStore);
}
elementProto.detachedCallback = function() {
	if (Modernizr.touchevents) return;
	dispatcher.unsubscribe(this.handleDispatcher);
	cursorStore.unsubscribe(this.handleStore);
}

document.registerElement('cursor-component', {
	prototype: elementProto
});